
import {Children} from 'react';
import {cloneElement} from "antd/lib/_util/reactNode";
import {useApi} from "../provider/ApiProvider";

export default function Can({currentRole, roles, children, ...props}){
    const {user} = useApi();


    const childrenWithProps = Children.map(children, child => {
        return cloneElement(child, props)
    })

    return roles.find(x => x === user.Role?.code)
    ? <>{childrenWithProps}</>
    : null



}
